import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'

export const ImageWrapper = styled.div<{
  $alignItems: 'flex-start' | 'center' | 'flex-end'
}>`
  display: flex;
  align-items: ${(props) => props.$alignItems};
  position: relative;
`

export const ImageIconWrapper = styled.div<{ $size: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  ${(props) => props.theme.marginRight}: 10px;

  flex-shrink: 0;
`

export const ImageContentWrapper = styled.div`
  text-align: ${(props) => props.theme.left};
  flex-grow: 1;
  min-width: 0;
`

export const MessageGreeting = styled.div`
  margin-top: 5px;
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${Colors.black};
`

export const StyledWrapperButton = styled.div`
  margin-top: 10px;
`

const wrapperStyles = css`
  margin-top: 20px;
`

export const WrapperGift = styled.div`
  ${wrapperStyles};
  cursor: pointer;

  &:first-child {
    margin-top: 0;
  }
`

export const WrapperGiftFromDeleted = styled.div`
  ${wrapperStyles};
`
